import { render, staticRenderFns } from "./AgentCommission.vue?vue&type=template&id=4261704e&lang=html"
import script from "./AgentCommission.vue?vue&type=script&lang=js"
export * from "./AgentCommission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports